// Temporary Modal
const location = document.querySelectorAll(".location");
const locationModal = document.querySelectorAll(".location__modal");
const locationClose = document.querySelectorAll(".location__close");
const locationBackdrop = document.querySelectorAll(".location__backdrop");

for (let i = 0; i < location.length; i++) {
  location[i].addEventListener("click", () => {
    locationModal[i].classList.add("is-active");
    locationBackdrop[i].classList.add("is-active");
  });

  locationClose[i].addEventListener("click", () => {
    locationModal[i].classList.remove("is-active");
    locationBackdrop[i].classList.remove("is-active");
  });
}